module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_7.4cd37c61.pdf";